import React from 'react';
import { Button } from '@/components/ui/button';
import { useWindowManager } from '@/contexts/WindowManager';
import { ArrowLeft, ArrowRight, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const MobileWindowSwitcher: React.FC = () => {
  const { windows, activeWindowId, focusWindow, closeWindow } = useWindowManager();
  
  const visibleWindows = windows.filter(w => !w.isMinimized);
  const currentIndex = visibleWindows.findIndex(w => w.id === activeWindowId);
  
  if (visibleWindows.length <= 1) return null;

  const handlePrevious = () => {
    const prevIndex = currentIndex > 0 ? currentIndex - 1 : visibleWindows.length - 1;
    focusWindow(visibleWindows[prevIndex].id);
  };

  const handleNext = () => {
    const nextIndex = currentIndex < visibleWindows.length - 1 ? currentIndex + 1 : 0;
    focusWindow(visibleWindows[nextIndex].id);
  };

  const activeWindow = visibleWindows[currentIndex];

  return (
    <div className="fixed top-4 left-4 right-4 z-[1000] flex items-center justify-between bg-black/20 backdrop-blur-md rounded-xl px-4 py-2 border border-white/10">
      <Button
        variant="ghost"
        size="sm"
        onClick={handlePrevious}
        className="text-white hover:bg-white/20"
      >
        <ArrowLeft className="w-4 h-4" />
      </Button>
      
      <div className="flex items-center gap-2 flex-1 mx-4">
        <span className="text-white text-sm font-medium truncate">
          {activeWindow?.title}
        </span>
        <span className="text-white/60 text-xs">
          {currentIndex + 1} of {visibleWindows.length}
        </span>
      </div>
      
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleNext}
          className="text-white hover:bg-white/20"
        >
          <ArrowRight className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => activeWindow && closeWindow(activeWindow.id)}
          className="text-white hover:bg-white/20"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};